function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgReading = function SvgReading(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Reading' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), React.createElement("path", {
    d: "M28.67 14H38v19.68h-9.34c-4 0-4.08 2.32-4.08 2.32H23.4s-.05-2.32-4.03-2.32h-9.33l-.04-.53V14h9.34c1.96 0 3.76 1.1 4.66 2.83.9-1.74 2.7-2.83 4.67-2.83zm-.3 18H36V16h-7.64c-1 0-2 .56-2.7 1.25-.73.7-.66 1.6-.66 2.7h-1.98c0-.98.05-2-.67-2.7-.72-.7-1.66-1.26-2.68-1.25h-7.64L12 32h7.67c1.84 0 2.8.1 3.35 1V19.97H25V33c.55-.9 1.5-1 3.36-1zM24 47C11.3 47 1 36.7 1 24S11.3 1 24 1s23 10.3 23 23-10.3 23-23 23zm0-1.84c11.7 0 21.16-9.47 21.16-21.16C45.16 12.3 35.7 2.84 24 2.84 12.3 2.84 2.84 12.3 2.84 24c0 11.7 9.47 21.16 21.16 21.16z"
  }));
};

SvgReading = pure(SvgReading);
SvgReading.displayName = 'SvgReading';
export default SvgReading;